var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        { staticClass: "sidebar stickyside", attrs: { id: "sidebar" } },
        [
          _c("div", { staticClass: "sidebar-inner v-slimscroll" }, [
            _c(
              "div",
              { staticClass: "sidebar-menu", attrs: { id: "sidebar-menu" } },
              [
                _c("ul", [
                  _c("li", { staticClass: "menu-title" }, [
                    _vm._v("Components")
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "a",
                      {
                        staticClass: "active",
                        attrs: { href: "#comp_alerts" }
                      },
                      [_vm._v("Alerts")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_breadcrumbs" } }, [
                      _vm._v("Breadcrumbs")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_buttons" } }, [
                      _vm._v("Buttons")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_cards" } }, [
                      _vm._v("Cards")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_dropdowns" } }, [
                      _vm._v("Dropdowns")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_pagination" } }, [
                      _vm._v("Pagination")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_progress" } }, [
                      _vm._v("Progress")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_tabs" } }, [_vm._v("Tabs")])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("a", { attrs: { href: "#comp_typography" } }, [
                      _vm._v("Typography")
                    ])
                  ])
                ])
              ]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-548dd6ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-548dd6ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/SidebarGoals.vue
// module id = null
// module chunks = 